import React from 'react';
import {styled} from '@linaria/react';
import {
  COLORS,
  FONT_SIZES,
  GenericIconName,
  Icon,
} from '@aboutyou/ui-components';
import {useTrackFeature} from '@aboutyou/tracking';
import {GetHeaderBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.types';
import {LinkType} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/meta_bar.types';
import {MetaBarLanguageCountrySwitch} from './MetaBarLanguageCountrySwitch';
import {MetaBarItemWithLink, MetaBarLinks} from './MetaBarLinks';
import {useOutletLinkConfig} from '../../../features/OutletLink/useOutletLinkConfig';

export const metaBarLinkTypes = [
  LinkType.LINK_TYPE_CONTACT,
  LinkType.LINK_TYPE_SECOND_HAND_SERVICE,
];

export const MetaBarContentView: React.FC<
  React.PropsWithChildren<GetHeaderBulkResponse['metaBarSection']>
> = ({countrySwitch, links}) => {
  const trackFeature = useTrackFeature();

  const {ayOutletUrl, outletLabel, showOutletLink} =
    useOutletLinkConfig('metabar_desktop');

  const handleOutletClick = () => {
    trackFeature({eventType: 'click', label: 'Outlet'});
  };

  return (
    <>
      <Content>
        {showOutletLink && (
          <StyledMetaBarItemWithLink
            to={ayOutletUrl}
            onClick={handleOutletClick}
            data-testid="ayOutletLink-metabar"
          >
            <StyledIcon asset={GenericIconName.Percent} size="XS" />
            {outletLabel}
          </StyledMetaBarItemWithLink>
        )}
        <MetaBarLinks
          links={links.filter(link => metaBarLinkTypes.includes(link.type))}
        />
      </Content>
      <Content>
        <MetaBarLanguageCountrySwitch countrySwitch={countrySwitch} />
      </Content>
    </>
  );
};

const StyledMetaBarItemWithLink = styled(MetaBarItemWithLink)`
  gap: 4px;
`;

const StyledIcon = styled(Icon)`
  background: ${COLORS.Yellow};
  border-radius: 3px;
`;

export const Content = styled.div`
  display: flex;
  height: 100%;
  color: ${COLORS.Grey1};
  font-size: ${FONT_SIZES.px10};
  border: solid ${COLORS.Grey3};
  border-width: 0 1px;

  ${MetaBarItemWithLink} {
    border: solid ${COLORS.Grey3};
    border-width: 0 1px 0 0;
    :last-child {
      border: none;
    }
  }
`;
